import { render, staticRenderFns } from "./pagePart1.vue?vue&type=template&id=3f217950&scoped=true"
import script from "./pagePart1.vue?vue&type=script&lang=js"
export * from "./pagePart1.vue?vue&type=script&lang=js"
import style0 from "./pagePart1.vue?vue&type=style&index=0&id=3f217950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f217950",
  null
  
)

export default component.exports